import { Category } from "./types";

// 四大分类与子分类（对齐参考站分类体系）
export const categories: Category[] = [
  {
    slug: "second-hand",
    name: "二手转让",
    desc: "数码家电、电脑办公与闲置物品转让",
    icon: "box",
    subCategories: [
      { slug: "phone", name: "手机数码" },
      { slug: "computer", name: "电脑办公" },
      { slug: "appliance", name: "家用电器" },
      { slug: "other", name: "其他闲置" },
    ],
  },
  {
    slug: "rental",
    name: "房屋租赁",
    desc: "整租、合租、写字楼与商铺",
    icon: "home",
    subCategories: [
      { slug: "whole", name: "整租" },
      { slug: "shared", name: "合租" },
      { slug: "office", name: "写字楼" },
      { slug: "shop", name: "商铺" },
    ],
  },
  {
    slug: "vehicle",
    name: "车辆买卖",
    desc: "轿车、货车与摩托车交易",
    icon: "car",
    subCategories: [
      { slug: "car", name: "轿车" },
      { slug: "truck", name: "货车" },
      { slug: "moto", name: "摩托车" },
    ],
  },
  {
    slug: "service",
    name: "生活服务",
    desc: "维修安装、家政保洁等本地服务",
    icon: "tool",
    subCategories: [
      { slug: "repair", name: "维修安装" },
      { slug: "cleaning", name: "家政保洁" },
      { slug: "education", name: "教育培训" },
      { slug: "other-service", name: "其他服务" },
    ],
  },
];
